import { render } from "./Loader.vue?vue&type=template&id=d78951f4&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=d78951f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d78951f4"

export default script